// eslint-disable-next-line import/no-cycle
import HTTP from '../http/common';

export default {
  login(params) {
    return HTTP.post('auth/signin', params);
  },

  refreshToken(params) {
    return HTTP.post('/auth/refreshtoken', params);
  },

  signup(params) {
    return HTTP.post('auth/signup', params);
  },

  emailConfirm(hash) {
    return HTTP.get(`auth/activate/${hash}`);
  },

  socialInit(socialName) {
    return HTTP.get(`auth/social/${socialName}`);
  },

  socialAuth(socialName, params) {
    return HTTP.post(`auth/${socialName}`, params);
  },

  forgotPassword(params) {
    return HTTP.post('/auth/forgotpassword', params);
  },

  init() {
    return HTTP.get('auth/init');
  },

};
